import { Injectable, inject } from '@angular/core';
import { MyAuthService } from '../../../auth/auth.service';
import { ProjectService } from '../project/project.service';

@Injectable({
  providedIn: 'root',
})
export class SessionService {
  private readonly authService = inject(MyAuthService);
  private readonly projectService = inject(ProjectService);

  logout(): void {
    this.projectService.closeProject(true);
    this.authService.logout();
  }
}
